import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Dialog as MuiDialog } from '@material-ui/core';
import styled from 'styled-components';
import GlobalTheme from '../../../styled/GlobalTheme';
import { Button } from '../../../components/buttons';
import { PRIMARY } from '../../../components/buttons/constants';
import { colors } from '../../../styled/theme';
import PiperTip from '../../../components/PiperTips/PiperTip';
import Pipers from '../../../components/Pipers/Pipers';

export const StyledExpiredModal = styled(MuiDialog)`
  &&{
    .MuiPaper-root{
      min-width: 312px;
      padding: 16px 40px;
      ${GlobalTheme.breakpoints.down('md')}{
        min-width: 0;
        width: 312px;
        max-width: 312px;
      }
      ${GlobalTheme.breakpoints.down('sm')}{
        width: 312px;
        background: ${colors.screenBackground};
      }
    }
  }
`;

const ExpiredContainer = styled.div`
  
`;
const ButtonContainer = styled.div`
  display:flex;
  justify-content:center;

`;
const StyledPiperTip = styled(PiperTip)`
  max-width: 312px;
  margin-top: 12px;
  margin-bottom: 30px;
  height: 260px
  align-items: self-start;
  grid-template-rows: auto auto;
  justify-content:center;
    & .tip {
      width: 257px;
      padding: 0;
      @media (max-width: 320px){
        width: 230px;
      }
    }
`;

const ExpiredModalContent = ({
  open,
  handleClose,
}) => (
  <StyledExpiredModal
    open={open}
    onBackdropClick={handleClose}
  >
    <ExpiredContainer>
      <StyledPiperTip
        Piper={Pipers.Piper1}
        position="top"
        trianglePosition="right"
        piperWidth="130px"
        justifyCenter
      >
        <FormattedMessage
          id="login.expirderModal.tip"
          defaultMessage="Wow! You’ve been away for a while! Please, login again."
        />
      </StyledPiperTip>
      <ButtonContainer>
        <Button
          onClick={() => handleClose()}
          type={PRIMARY}
        >
          <FormattedMessage
            id="k.ok"
            defaultMessage="ok"
          />
        </Button>
      </ButtonContainer>
    </ExpiredContainer>
  </StyledExpiredModal>
);

ExpiredModalContent.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

ExpiredModalContent.defaultProps = {
};

export default ExpiredModalContent;
